import { useState, useEffect } from "react";

// Hook
export function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.outerWidth : undefined,
      height: isClient ? window.outerHeight : undefined
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return () => {};
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

export function useWindowWidth(max: number) {
  const size = useWindowSize();
  const getWidth = () => Math.min(size.width ?? 0, max);
  const [width, changeWidth] = useState(getWidth());

  useEffect(() => {
    changeWidth(getWidth());
  }, [size.width]);

  return width;
}
